import Guid from "common/values/guid/guid";
import NetworkDomain from "common/values/network-domain/network-domain";
import LegalEntity from "legal-entities/entities/legal-entity/legal-entity";
import EntityName from "legal-entities/values/entity-name/entity-name";

export default class LegalEntityAPIResponse {
    id?: string;
    entityName?: string;
    emailDomains?: string[];
    isVendor?: boolean;
    isClient?: boolean;

    deserialize(): LegalEntity {
        if (!this.id) {
            throw new Error('LegalEntityAPIResponse: id is undefined');
        }

        if (!this.entityName) {
            throw new Error('LegalEntityAPIResponse: entityName is undefined');
        }

        if (!this.emailDomains) {
            throw new Error('LegalEntityAPIResponse: emailDomains is undefined');
        }

        const emailDomainInstances = this.emailDomains.map(domain => new NetworkDomain(domain));

        return new LegalEntity(
            new Guid(this.id),
            new EntityName(this.entityName),
            this.isClient,
            this.isVendor,
            emailDomainInstances
        );
    }
}
